import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');

    if (!sessionId) {
      toast.error('Google login failed');
      navigate('/login');
      return;
    }

    // Get pending referral code from localStorage (set by LoginPage)
    const pendingReferral = localStorage.getItem('pending_referral') || '';

    api.post('/auth/google-session', { session_id: sessionId, referral_code: pendingReferral })
      .then(res => {
        localStorage.removeItem('pending_referral');
        localStorage.setItem('neonplay_token', res.data.token);
        setUser(res.data.user);
        toast.success('Google login successful!');
        const role = res.data.user.role;
        navigate(role === 'admin' ? '/admin' : role === 'sub_admin' ? '/subadmin' : '/');
      })
      .catch(err => {
        localStorage.removeItem('pending_referral');
        toast.error(err.response?.data?.detail || 'Google login failed');
        navigate('/login');
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--neon-bg)' }}>
      <div className="text-lg font-bold pulse-glow p-4 rounded-xl neon-border" style={{ color: 'var(--neon-primary)' }}>
        Logging in with Google...
      </div>
    </div>
  );
}
